export const environment = {
    appVersion: require('../../package.json').version,
    production: true,

    //Mapbox
    mapBoxKey:
        'pk.eyJ1Ijoic3VicmF0MDA3IiwiYSI6ImNrYjNyMjJxYjBibnIyem55d2NhcTdzM2IifQ.-NnMzrAAlykYciP4RP9zYQ',

    // Prod
    baseUrl: 'https://hajdyhbdk1.execute-api.ap-south-1.amazonaws.com/FMS/fms',
    NewBaseUrl: 'https://c9aafaqhrh.execute-api.ap-south-1.amazonaws.com/prod',
    websocketUrl: 'wss://yo8psd9gu1.execute-api.ap-south-1.amazonaws.com/PROD',
    opsBaseUrl:'https://iezc6sibhe.execute-api.ap-south-1.amazonaws.com/operator',
    // google maps
    googleMapsAPIKey: 'AIzaSyAvp27Yn_Dx-gHqQF58JIiLHrGPOEBoKW0',

    // what3words
    what3WordsAPIkey: '8EA4VRRL',
    
    // This is a legacy key, if chnaged shall be changed for get requests in backend as well
    randomKey: '888fd05b01f92886a971a143edba513862b8ff2cd0cc22774b68c90004bbec1b'
};
